/* ============================================================
   GOLDEN AUREA CORP — Main JavaScript
   Compatible with: Shopify Dawn / Canyon themes
   Includes: Sacred Geometry · Torus Animation · 432Hz · Cursor
   ============================================================ */

/* ── CURSOR ── */
const cur=document.getElementById('cur'),cur2=document.getElementById('cur2');
let mx=window.innerWidth/2,my=window.innerHeight/2,rx=mx,ry=my;
document.addEventListener('mousemove',e=>{mx=e.clientX;my=e.clientY;
  cur.style.left=mx+'px';cur.style.top=my+'px';});
(function loop(){rx+=(mx-rx)*.1;ry+=(my-ry)*.1;
  cur2.style.left=rx+'px';cur2.style.top=ry+'px';
  requestAnimationFrame(loop);})();
document.querySelectorAll('a,button,.el-card,.prod,.scell').forEach(el=>{
  el.addEventListener('mouseenter',()=>{
    cur2.style.transform='translate(-50%,-50%) scale(1.8)';
    cur2.style.borderColor='rgba(212,168,67,.8)';
    cur2.style.boxShadow='0 0 12px rgba(212,168,67,.3)';});
  el.addEventListener('mouseleave',()=>{
    cur2.style.transform='translate(-50%,-50%) scale(1)';
    cur2.style.borderColor='rgba(212,168,67,.4)';
    cur2.style.boxShadow='none';});
});

/* ── SACRED GEOMETRY ── */
const gc=document.getElementById('geom');
const gx=gc.getContext('2d');
function rsz(){gc.width=window.innerWidth;gc.height=window.innerHeight;}
rsz();window.addEventListener('resize',rsz);
let ga=0;
const colors=['rgba(107,63,160,','rgba(15,92,107,','rgba(107,31,58,','rgba(212,168,67,'];
function drawGeom(){
  gx.clearRect(0,0,gc.width,gc.height);
  const cx=gc.width/2,cy=gc.height/2;
  ga+=.001;
  // Flower of Life
  [60,130,200,280,360].forEach((r,i)=>{
    gx.beginPath();gx.arc(cx,cy,r,0,Math.PI*2);
    gx.strokeStyle=colors[i%4]+`${.04-i*.006})`;
    gx.lineWidth=.6;gx.stroke();
    for(let k=0;k<6;k++){
      const a=ga+k*(Math.PI/3);
      const px=cx+Math.cos(a)*r,py=cy+Math.sin(a)*r;
      gx.beginPath();gx.arc(px,py,r*.5,0,Math.PI*2);
      gx.strokeStyle=colors[i%4]+`${.02-i*.003})`;
      gx.lineWidth=.4;gx.stroke();
    }
  });
  // Metatron Cube lines
  for(let k=0;k<12;k++){
    const a=ga*.5+k*(Math.PI/6);
    gx.beginPath();gx.moveTo(cx,cy);
    gx.lineTo(cx+Math.cos(a)*450,cy+Math.sin(a)*450);
    gx.strokeStyle='rgba(212,168,67,.015)';
    gx.lineWidth=.5;gx.stroke();
  }
  requestAnimationFrame(drawGeom);
}
drawGeom();

/* ── TORUS ENERGY CANVAS ── */
const ec=document.getElementById('energyCanvas');
const ex=ec.getContext('2d');
const isMobile=window.innerWidth<=600;
const eSize=isMobile?220:280;
ec.width=eSize;ec.height=eSize;
const ecx=eSize/2,ecy=eSize/2;
let ea=0;
function drawEnergy(){
  ex.clearRect(0,0,eSize,eSize);
  ea+=.014;
  for(let i=0;i<9;i++){
    const phase=ea+i*(Math.PI/4.5);
    const r=22+i*13;
    const ox=Math.cos(phase)*16,oy=Math.sin(phase)*7;
    ex.beginPath();
    ex.ellipse(ecx+ox,ecy+oy,r,r*.38,phase*.35,0,Math.PI*2);
    const g=ex.createLinearGradient(ecx-r,ecy,ecx+r,ecy);
    g.addColorStop(0,`rgba(107,63,160,${.3-i*.025})`);
    g.addColorStop(.5,`rgba(212,168,67,${.35-i*.03})`);
    g.addColorStop(1,`rgba(15,92,107,${.3-i*.025})`);
    ex.strokeStyle=g;ex.lineWidth=.9;ex.stroke();
  }
  const cg=ex.createRadialGradient(ecx,ecy,0,ecx,ecy,42);
  cg.addColorStop(0,'rgba(212,168,67,.18)');
  cg.addColorStop(.5,'rgba(107,63,160,.08)');
  cg.addColorStop(1,'rgba(212,168,67,0)');
  ex.beginPath();ex.arc(ecx,ecy,42,0,Math.PI*2);
  ex.fillStyle=cg;ex.fill();
  for(let i=0;i<14;i++){
    const a=ea*1.6+i*(Math.PI/7);
    const r=58+Math.sin(ea*2+i)*.18*i;
    const px=ecx+Math.cos(a)*r,py=ecy+Math.sin(a)*r*.52;
    ex.beginPath();ex.arc(px,py,1.6,0,Math.PI*2);
    const alpha=.45+Math.sin(ea+i)*.3;
    const hue=i%2===0?'rgba(240,201,106,':'rgba(167,99,208,';
    ex.fillStyle=hue+alpha+')';ex.fill();
  }
  requestAnimationFrame(drawEnergy);
}
drawEnergy();

/* ── 432 Hz TONE ── */
let actx=null,playing=false,g1,o1,o2,g2;
document.getElementById('soundBtn').addEventListener('click',()=>{
  if(!actx)actx=new(window.AudioContext||window.webkitAudioContext)();
  if(!playing){
    g1=actx.createGain();g1.gain.setValueAtTime(0,actx.currentTime);
    g1.gain.linearRampToValueAtTime(.055,actx.currentTime+2.5);
    g1.connect(actx.destination);
    o1=actx.createOscillator();o1.type='sine';o1.frequency.value=432;
    o1.connect(g1);o1.start();
    g2=actx.createGain();g2.gain.value=.028;g2.connect(actx.destination);
    o2=actx.createOscillator();o2.type='sine';o2.frequency.value=216;
    o2.connect(g2);o2.start();
    playing=true;
    document.getElementById('soundBtn').classList.add('on');
    document.getElementById('soundLabel').textContent='Playing';
  } else {
    g1.gain.linearRampToValueAtTime(0,actx.currentTime+1.8);
    setTimeout(()=>{o1.stop();o2.stop();playing=false;},1900);
    document.getElementById('soundBtn').classList.remove('on');
    document.getElementById('soundLabel').textContent='432 Hz';
  }
});

/* ── SCROLL REVEALS ── */
const obs=new IntersectionObserver(entries=>{
  entries.forEach((e,i)=>{
    if(e.isIntersecting){
      const idx=[...document.querySelectorAll('.reveal')].indexOf(e.target);
      setTimeout(()=>e.target.classList.add('in'),(idx%5)*80);
      obs.unobserve(e.target);
    }
  });
},{threshold:.1});
document.querySelectorAll('.reveal').forEach(el=>obs.observe(el));
